import { useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import MainButton from "../../Buttons/MainButton";
import Input from "../../Inputs/Input";
import Title from "../../Title/Title";
import { fileURL, useFetch, usePOST } from "../../../ApiS";
import { Bounce, toast } from "react-toastify";
import PasswordInput from "../../Inputs/Passwordinput";
import AddImage from "../../../ApiS/AddImage/AddImage";
import { useEffect, useState } from "react";
import Loader from "../../Loader";
import AddFiles from "../../AddFiles/AddFiles";

interface New {
  id: string | number;
  ar_title: string;

  en_title: string;

  ar_description: string;

  en_description: string;

  images: Image[];
}
interface Image {
  id: string | number;
  url: string;
}

interface NewsData {
  data: New;
}

const Create_news: React.FC = () => {
  const notify = (message: string) => {
    toast.error(message, {
      position: "top-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Bounce,
    });
  };
  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();
  const enabled = id ? true : false;

  const { data, isLoading } = useFetch(
    `admin/news/${id}`,
    `news/${id}`,
    enabled
  );
  let dataOld = data?.data;

  const {
    mutation,
    handleChangeInput,
    handleChangeArrayFiles,
    handleSubmit,
    setFormData,
    formData,
    viewFile,
    setFiles,
    setViewFile,
    setViewFiles,
    files,
    viewFiles,
    counter,

    setCounter,
  } = usePOST(
    {
      _method: id ? "PUT" : "post",
    },
    () => navigate("/news"),
    () => notify("الايميل غير صحيح يرجى ادخال ايميل صحيح")
  );

  const [oldImages, setOldImages] = useState<any>({});

  const [userImages, setUserImages] = useState(dataOld?.images);
  useEffect(() => {
    setUserImages(dataOld?.images);
  }, [dataOld?.images]);

  return isLoading ? (
    <Loader />
  ) : (
    <>
    {mutation.isLoading && <Loader />}
      <Row>
        <Col lg={4} md={4}>
          <Title title={id ? "تعديل  الأخبار" : "أنشاء الأخبار"} />
        </Col>
      </Row>
      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="ar_title"
            onChange={handleChangeInput}
            title="العنوان بالعربي"
            placeholder="أدخل العنوان بالعربي "
            className="!w-full"
            defaultValue={dataOld?.ar_title}
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="en_title"
            onChange={handleChangeInput}
            title="العنوان بالانكليزي"
            placeholder="أدخل العنوان بالانكليزي "
            className="!w-full"
            defaultValue={dataOld?.en_title}
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="ar_description"
            onChange={handleChangeInput}
            title="العنوان بالعربي"
            placeholder="أدخل العنوان بالعربي "
            className="!w-full"
            defaultValue={dataOld?.ar_description}
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            type="text"
            name="en_description"
            onChange={handleChangeInput}
            title="العنوان بالانكليزي"
            placeholder="أدخل العنوان بالانكليزي "
            className="!w-full"
            defaultValue={dataOld?.en_description}
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <label className="block text-gray-700 font-bold mb-2" htmlFor="image">
            أضف صور الأعلان
          </label>
          <AddFiles
            type={"IMAGES" || "pdf"}
            name="images[]"
            newImages={viewFiles}
            setnewImages={setViewFiles}
            setFormData={setFormData}
            onChange={handleChangeArrayFiles}
            setImagesToSend={setFiles}
            formData={formData}
            counter={counter}
            setCounter={setCounter}
            setOldImages={setOldImages}
            viewImages={viewFiles}
            setViewImages={setViewFiles}
            images={id ? userImages : ""}
            setUserImages={setUserImages}
            imagesToSend={files}
          />
        </Col>
      </Row>
      
      <Col
        lg={11}
        md={5}
        sm={11}
        className="flex lg:justify-center max-lg:mx-auto  !mt-4 "
      >
        <MainButton
          onClick={() => handleSubmit(id ? `admin/news/${id}` : "admin/news")}
          titlebtn="انشاء"
          className="w-[400px] "
        />
      </Col>
    </>
  );
};

export default Create_news;
